import { Component, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ActivatedRoute } from '@angular/router';
import { UserRolesService } from 'src/app/services/user-roles.service';
import { Router, RouterLink } from '@angular/router';
import { getRoleContext, userRoleContext } from 'src/app/constants/role-details.constants';
import { SupplierService } from 'src/app/services/supplier.service';


@Component({
  selector: 'app-user-profile',
  standalone: true,
  imports: [
    MatCardModule,
    MatDividerModule,
    MatTabsModule,
    MatIconModule,
    FlexLayoutModule,
    RouterLink

  ],
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss'
})

export class UserProfileComponent {
  private userRoleService = inject(UserRolesService);
  private supplierService = inject(SupplierService);
  router = inject(Router);
  userUniqueId: any;
  userData: any;
  showAvatar = true;

  constructor(
    private route: ActivatedRoute,
  ) { }
  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.userUniqueId = params.get('id');
    });

    this.userRoleService.getUserProfile(this.userUniqueId).subscribe({
      next: (res: any) => {
        if (res) {
          this.userData = res
        }

      },
      error: (err: any) => {
        // this.toasterServiceService.showError("Something went wrong!");
      },
      complete: () => { }
    });
  }

  redirectToOrgProfile() {
    if (!this.userData?.parentOrg?.uniqueId) {
      return;
    }
    const roleContext = getRoleContext();
    if (roleContext === userRoleContext.Supplier) {
      this.supplierService.getOrgAndLinks().subscribe((orgDetails: any) => {
        this.supplierService.getOranizationUserList(this.userData.parentOrg.uniqueId).subscribe((orgUserList: any) => {
          this.router.navigate(['/my-organization/organization-users'], {
            state: {
              orgDetails: orgDetails.organization,
              users: orgUserList
            }
          });
        })
      })
    } else if (roleContext === userRoleContext.Buyer) {
      this.router.navigate(['/organization/buyer', this.userData.parentOrg.uniqueId]);
    }
  }

  getFormattedAddress(): string {
    if (!this.userData?.parentOrg) {
      return '';
    }
    const org = this.userData.parentOrg;
    const addressParts = [
      org.streetAddress,
      org.city,
      org.stateProvince,
      org.country
    ]
      .map(part => part?.trim())
      .filter(part => part);
    
    let address = addressParts.join(', ');
    const postalCode = org.postalCode?.trim();
    if (postalCode) {
      address += address ? ' - ' + postalCode : postalCode;
    }
    return address;
  }

  onImageError(): void {
    this.showAvatar = false;
  }
}
